export default __webpack_public_path__ + "static/default-thumbnail-272fb5793c3e03378f02271686c9b284.jpg";